import { Component, OnInit, ElementRef, Input, OnChanges } from '@angular/core';
@Component({
    selector: 'button[bw-button-legacy], button[bw-outlined-button-legacy], button[bw-link-button-legacy], button[bw-small-button-legacy], button[bw-small-outlined-button-legacy], button[bw-icon-button-legacy]',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class ButtonComponentLegacy implements OnInit, OnChanges {
  @Input() disabled: boolean;
  @Input() processing: boolean;
  @Input() fluidWidth: boolean;

  /** Whether the button is fluid and can stretch to it's container. */
  readonly isFluidButton: boolean = this._getHostElement().hasAttribute('fluidWidth');

  /** Whether the button is a small button. */
  readonly isSmallButton: boolean =
    this._hasHostAttributes('bw-small-outlined-button-legacy') || this._hasHostAttributes('bw-small-button-legacy');

  /** Whether the button is an outlined button. */
  readonly isOutlined: boolean = this._hasHostAttributes('bw-small-outlined-button-legacy') || this._hasHostAttributes('bw-outlined-button-legacy');

  /** Whether the button is an outlined button. */
  readonly isLink: boolean = this._hasHostAttributes('bw-link-button-legacy');

  /** Whether the button is an icon button. */
  readonly isIconButton: boolean = this._hasHostAttributes('bw-icon-button-legacy');

  constructor(public _elementRef: ElementRef) {
    if (this.isSmallButton) {
      (this._getHostElement() as HTMLElement).classList.add('small');
    }

    if (this.isOutlined) {
      (this._getHostElement() as HTMLElement).classList.add('outlined');
    }

    if (this.isLink) {
      (this._getHostElement() as HTMLElement).classList.add('link-button');
    }

    if (this.isFluidButton) {
      (this._getHostElement() as HTMLElement).classList.add('fluid-width');
    }

    if (this.isIconButton) {
      (this._getHostElement() as HTMLElement).classList.add('icon-button');
    }
  }

  ngOnInit() {
    this.setDisabled(this.processing || this.disabled);
  }

  private setDisabled(isDisabled: boolean = false) {
    if (isDisabled) {
      (this._getHostElement() as HTMLElement).setAttribute('disabled', '');
    } else {
      (this._getHostElement() as HTMLElement).removeAttribute('disabled');
    }
  }

  _getHostElement() {
    return this._elementRef.nativeElement;
  }

  _hasHostAttributes(...attributes: string[]) {
    return attributes.some((attribute) => this._getHostElement().hasAttribute(attribute));
  }

  ngOnChanges(changes: import('@angular/core').SimpleChanges): void {
    this.setDisabled(changes['processing']?.currentValue === true || changes['disabled']?.currentValue === true || this.disabled === true);
  }
}
